import { Box, Typography } from "@mui/material";
import type { SectionTitleAndSubtitleProps } from "./types/SectionTitleAndSubtitleProps";

export function SectionTitleAndSubtitle({
  title,
  subTitle,
  color,
  textAlign = "center",
}: SectionTitleAndSubtitleProps) {
  return (
    <Box sx={{ textAlign: textAlign }}>
      <Typography
        variant="h2"
        sx={{
          fontSize: {
            xs: "34px",
            sm: "40px",
          },
          marginBottom: "-5px",
          fontWeight: "bold",
          textTransform: "uppercase",
          color: color,
        }}
      >
        {title}
      </Typography>
      {subTitle && (
        <Typography variant="h6" sx={{ fontSize: { xs: "14px", sm: "16px" }, color: color }}>
          {subTitle}
        </Typography>
      )}
    </Box>
  );
}
